class MobileFilters {
  constructor() {
    this.mobileFilterButton = document.getElementById("mobile-filter-button");
    this.tagsFilterButton = document.getElementById("filters-button");
    this.facetDrawer = document.getElementById("Facet-Drawer");
    this.filterDrawerCloseBtn = document.getElementById(
      "filter-drawer-close-btn"
    );
    this.clickCapture =
      document.querySelector(".click-capture") ||
      document.querySelector(".searchform--click-capture");
    this.applyButton = document.querySelector(".mobile-filters-apply");

    this._addEventListeners();
  }

  _toggleDrawer() {
    if (!this.facetDrawer) {
      return;
    }

    const drawerIsCurrentlyActive =
      this.facetDrawer.classList.contains("active");

    if (drawerIsCurrentlyActive) {
      this._closeDrawer();
    } else {
      this._openDrawer();
    }
  }

  _openDrawer() {
    if (!this.facetDrawer) return;

    this.facetDrawer.classList.add("active");
    document.body.classList.add("overflow-hidden");
    document.body.style.overflow = "hidden";

    this._hideChatElements();

    if (this.clickCapture) {
      this.clickCapture.classList.add("active");
    }
  }

  _closeDrawer() {
    if (!this.facetDrawer) return;

    if (this.facetDrawer.classList.contains("active")) {
      this.facetDrawer.classList.remove("active");

      document.body.classList.remove("overflow-hidden");
      document.body.style.overflow = "";

      this._showChatElements();

      if (this.clickCapture) {
        this.clickCapture.classList.remove("active");
      }
    }
  }

  _hideChatElements() {
    const chatSelectors = [
      "#shopify-chat",
      '[id*="shopify-chat"]',
      '[class*="chat-widget"]',
      '[class*="shopify-chat"]',
      'iframe[src*="chat"]',
      'iframe[src*="shopify"]',
      ".chat-app",
      '[id*="chat"]',
      'div[id*="ShopifyChat"]',
      'iframe[title*="chat"]',
    ];

    this.hiddenChatElements = [];

    chatSelectors.forEach((selector) => {
      const elements = document.querySelectorAll(selector);
      elements.forEach((element) => {
        if (element && element.style.display !== "none") {
          const originalDisplay =
            element.style.display || getComputedStyle(element).display;
          this.hiddenChatElements.push({
            element: element,
            originalDisplay: originalDisplay,
          });
          element.style.display = "none";
        }
      });
    });
  }

  _showChatElements() {
    if (this.hiddenChatElements && this.hiddenChatElements.length > 0) {
      this.hiddenChatElements.forEach((item) => {
        if (item.element) {
          item.element.style.display =
            item.originalDisplay === "none" ? "" : item.originalDisplay;
        }
      });
      this.hiddenChatElements = [];
    }
  }

  _addEventListeners() {
    if (this.mobileFilterButton) {
      this.mobileFilterButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this._toggleDrawer();
      });
    }

    if (this.tagsFilterButton) {
      this.tagsFilterButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this._openDrawer();
      });
    }

    if (this.filterDrawerCloseBtn) {
      this.filterDrawerCloseBtn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this._closeDrawer();
      });
    }

    if (this.clickCapture) {
      this.clickCapture.addEventListener("click", (event) => {
        if (this.facetDrawer && this.facetDrawer.classList.contains("active")) {
          this._closeDrawer();
        }
      });
    }

    if (this.applyButton) {
      this.applyButton.addEventListener("click", (event) => {});
    }

    document.addEventListener("keydown", (event) => {
      if (
        event.key === "Escape" &&
        this.facetDrawer &&
        this.facetDrawer.classList.contains("active")
      ) {
        this._closeDrawer();
      }
    });

    document.body.addEventListener("click", (event) => {
      const isMobileFilterButton = event.target.closest(
        "#mobile-filter-button"
      );
      const isFiltersButton = event.target.closest("#filters-button");

      if (isMobileFilterButton) {
        event.preventDefault();
        event.stopPropagation();
        this._toggleDrawer();
      } else if (isFiltersButton) {
        event.preventDefault();
        event.stopPropagation();
        this._openDrawer();
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    window.mobileFiltersInstance = new MobileFilters();

    setTimeout(() => {
      setupMobileFiltersAccordion();
    }, 100);
  }, 100);

  function setupMobileFiltersAccordion() {
    const facetDrawer = document.getElementById("Facet-Drawer");
    if (!facetDrawer) {
      setTimeout(setupMobileFiltersAccordion, 500);
      return;
    }

    function handleDetailsToggle(event) {
      const currentDetail = event.target;

      if (currentDetail.open) {
        const allDetails = facetDrawer.querySelectorAll(
          "details.thb-filter.js-filter"
        );
        allDetails.forEach((detail) => {
          if (detail !== currentDetail && detail.open) {
            detail.open = false;
          }
        });
      }
    }

    facetDrawer.addEventListener(
      "toggle",
      function (event) {
        if (event.target.matches("details.thb-filter.js-filter")) {
          handleDetailsToggle(event);
        }
      },
      true
    );
  }
});
